import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Subject, Subscription, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, catchError, map } from 'rxjs/operators';
import { MSMEParticipant } from '../../../../../shared/models/ParticipantMSME';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-view-enrolled-msme',
  templateUrl: './view-enrolled-msme.component.html',
  styleUrl: './view-enrolled-msme.component.css'
})

export class ViewEnrolledMSMEComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private loadDataSubscription: Subscription = new Subscription();

  dataSource1 = new MatTableDataSource<MSMEParticipant>([]);
  displayedColumns: string[] = [
    'serialNumber', 'eventId', 'udyamNumber',
    'nameOfEnterprise', 'userName', 'userMobileNo',
    'userEmail', 'status'
  ];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 20;
  length: number = 0;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  eventId: any;
  allrecord: any[] = [];

  viewMSMEParticipantForm: FormGroup;

  dtoPagination = {
    EventId: '',
    PageNumber: 1,
    PageSize: 20,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: ''
  };

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public commonService: CommonService
  ) {
    this.viewMSMEParticipantForm = new FormGroup({
      search: new FormControl('')
    });
  }
    loggedInUserName = sessionStorage.getItem('name');
  ngOnInit() {

    this.route.params.subscribe(params => {
      this.eventId = params['eventid']; //'SantComp_SkilDev_89'; //
    });
    this.dtoPagination.EventId = this.eventId;
    this.dtoPagination.PageSize = 20;
    this.dtoPagination.SearchCol = this.commonService.searchText;

      if (this.loggedInUserName === 'RAMP_MSSIDC') {

    this.displayedColumns =
      this.displayedColumns.filter(
        x => x !== 'userMobileNo' && x !== 'userEmail'
      );

  }
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.dtoPagination.SortColumn = this.sort.active;
          this.dtoPagination.SortDirection = this.sort.direction;
          this.dtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEPARTICIPANTLIST, this.dtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp.totalRecords;
          }
          return resp?.namedDataSets?.data || {};
        })
      )
      .subscribe(data => {

        this.dataSource1 = data;

        this.adjustPaginator();
      });
  }

  onSearchClick(searchValue: string): void {

    const searchControl = this.viewMSMEParticipantForm.get('search');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.dtoPagination.SearchTerm = searchValue.trim();
      this.dtoPagination.SearchCol = this.commonService.searchText;
      
      this.loadData();
    }
  }

  resetPage() {
    this.dtoPagination.SearchTerm = "";
    this.dtoPagination.SearchCol = this.commonService.searchText;
   
    this.loadData()
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.dtoPagination.PageNumber = this.pageIndex + 1;
    this.dtoPagination.PageSize = this.pageSize;

    this.loadData();
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages > 0 ? totalPages - 1 : 0;
      this.pagination.pageIndex = this.pageIndex;
    }
  }

  exportToExcel(): void {
    const fileName = 'Enrolled_MSME_Participants.xlsx';

    const Dto = {
      EventId: this.eventId,
      PageNumber: 1,
      PageSize: 9999999,   // fetch all
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: ""
    };

    this.apiService.getRequest(API_ENDPOINTS.MSME.GETMSMEPARTICIPANTLIST, Dto).subscribe(
      (result: any) => {
        const records = result?.namedDataSets?.data || [];

        if (result.status && records.length > 0) {
          const excelData = records.map((item: any, index: number) => ({
            'Sr. No': index + 1,
            'Event ID': item.EventId,
            'Udyam Number': item.UdyamNumber,
            'Name of Enterprise': item.NameOfEnterprise,
            'Participant Name': item.UserName || 'N/A',
            'Mobile Number Registered with Udyam': item.UserMobileNo,
            'Email': item.UserEmail,
            'Status': item.Status,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          // Column widths
          worksheet['!cols'] = [
            { wch: 8 },  // Sr. No
            { wch: 15 }, // Event ID
            { wch: 25 }, // Udyam Number
            { wch: 40 }, // Name of Enterprise
            { wch: 25 }, // Participant Name
            { wch: 25 }, // Mobile Number
            { wch: 30 }, // Email
            { wch: 20 }, // Status
          ];

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Enrolled Participants': worksheet },
            SheetNames: ['Enrolled Participants'],
          };

          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        } else {
          this.toastr.error('No participants available to export.');
        }
      },
      (error: any) => {
        console.error('Export error:', error);
        this.toastr.error('Failed to fetch participant data.');
      }
    );
  }




  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
